import ConfirmRequest from './ConfirmRequest';

export default ConfirmRequest;
